import styles from "./styles.module.css";

export default function CardContainer({ children }) {
  const { container } = styles;

  return <div className={container}>{children}</div>;
}
